import isNil from 'lodash/isNil';

export function calculateSurchargeTax(taxPercent = 0, totalSurcharge) {
  const totalVatSurcharge = Math.round(!isNil(taxPercent) ? (taxPercent * totalSurcharge) / 100 : 0);
  return totalVatSurcharge;
}
